var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37, _rect38, _rect39, _rect40, _rect41, _rect42, _rect43, _rect44, _rect45, _rect46, _rect47, _rect48, _rect49, _rect50, _rect51, _rect52, _rect53, _rect54, _rect55, _rect56, _rect57, _rect58, _rect59, _rect60, _rect61, _rect62, _rect63;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgThumbnail3B(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 328,
    height: 225,
    viewBox: "0 0 328 225",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 328,
    height: 225,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 266.277,
    y: 9.45557,
    width: 23.7681,
    height: 4.6875,
    fill: "#E0E0E0"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 237.756,
    y: 9.45557,
    width: 23.7681,
    height: 4.6875,
    fill: "#E0E0E0"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 294.725,
    y: 9.45557,
    width: 23.7681,
    height: 4.6875,
    fill: "#E0E0E0"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 9.50684,
    y: 9.45557,
    width: 95.0725,
    height: 4.6875,
    fill: "#E0E0E0"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 9.50684,
    y: 21.1743,
    width: 308.986,
    height: 1.875,
    fill: "#E0E0E0"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 9.50684,
    y: 32.4243,
    width: 47.5362,
    height: 4.6875,
    fill: "#E0E0E0"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 272.903,
    y: 63.4497,
    width: 45.5891,
    height: 7.58929,
    fill: "#EEEEEE",
    stroke: "#CCCCCC"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 227.314,
    y: 63.4497,
    width: 45.5891,
    height: 7.58929,
    fill: "#EEEEEE",
    stroke: "#CCCCCC"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 181.726,
    y: 63.4497,
    width: 45.5891,
    height: 7.58929,
    fill: "#EEEEEE",
    stroke: "#CCCCCC"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 9.50684,
    y: 63.4497,
    width: 28.5217,
    height: 7.58929,
    fill: "#EEEEEE",
    stroke: "#CCCCCC"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 38.0293,
    y: 63.4497,
    width: 143.696,
    height: 7.58929,
    fill: "#EEEEEE",
    stroke: "#CCCCCC"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 272.903,
    y: 71.041,
    width: 45.5891,
    height: 7.59375,
    stroke: "#CCCCCC"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 272.903,
    y: 86.2393,
    width: 45.5891,
    height: 7.59375,
    stroke: "#CCCCCC"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 272.903,
    y: 101.433,
    width: 45.5891,
    height: 7.59375,
    stroke: "#CCCCCC"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 272.903,
    y: 116.631,
    width: 45.5891,
    height: 7.59375,
    stroke: "#CCCCCC"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 272.903,
    y: 78.6401,
    width: 45.5891,
    height: 7.59375,
    stroke: "#CCCCCC"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 272.903,
    y: 93.8379,
    width: 45.5891,
    height: 7.59375,
    stroke: "#CCCCCC"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 272.903,
    y: 109.032,
    width: 45.5891,
    height: 7.59375,
    stroke: "#CCCCCC"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 272.903,
    y: 124.229,
    width: 45.5891,
    height: 7.59375,
    stroke: "#CCCCCC"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 227.314,
    y: 71.041,
    width: 45.5891,
    height: 7.59375,
    stroke: "#CCCCCC"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 227.314,
    y: 86.2393,
    width: 45.5891,
    height: 7.59375,
    stroke: "#CCCCCC"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 227.314,
    y: 101.433,
    width: 45.5891,
    height: 7.59375,
    stroke: "#CCCCCC"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 227.314,
    y: 116.631,
    width: 45.5891,
    height: 7.59375,
    stroke: "#CCCCCC"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 227.314,
    y: 78.6401,
    width: 45.5891,
    height: 7.59375,
    stroke: "#CCCCCC"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 227.314,
    y: 93.8379,
    width: 45.5891,
    height: 7.59375,
    stroke: "#CCCCCC"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 227.314,
    y: 109.032,
    width: 45.5891,
    height: 7.59375,
    stroke: "#CCCCCC"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 227.314,
    y: 124.229,
    width: 45.5891,
    height: 7.59375,
    stroke: "#CCCCCC"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 181.726,
    y: 71.041,
    width: 45.5891,
    height: 7.59375,
    stroke: "#CCCCCC"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 181.726,
    y: 86.2393,
    width: 45.5891,
    height: 7.59375,
    stroke: "#CCCCCC"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 181.726,
    y: 101.433,
    width: 45.5891,
    height: 7.59375,
    stroke: "#CCCCCC"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 181.726,
    y: 116.631,
    width: 45.5891,
    height: 7.59375,
    stroke: "#CCCCCC"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 181.726,
    y: 78.6401,
    width: 45.5891,
    height: 7.59375,
    stroke: "#CCCCCC"
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 181.726,
    y: 93.8379,
    width: 45.5891,
    height: 7.59375,
    stroke: "#CCCCCC"
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 181.726,
    y: 109.032,
    width: 45.5891,
    height: 7.59375,
    stroke: "#CCCCCC"
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 181.726,
    y: 124.229,
    width: 45.5891,
    height: 7.59375,
    stroke: "#CCCCCC"
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    x: 9.50684,
    y: 71.041,
    width: 28.5217,
    height: 7.59375,
    stroke: "#CCCCCC"
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    x: 9.50684,
    y: 86.2393,
    width: 28.5217,
    height: 7.59375,
    stroke: "#CCCCCC"
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    x: 9.50684,
    y: 101.433,
    width: 28.5217,
    height: 7.59375,
    stroke: "#CCCCCC"
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    x: 9.50684,
    y: 116.631,
    width: 28.5217,
    height: 7.59375,
    stroke: "#CCCCCC"
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    x: 9.50684,
    y: 78.6401,
    width: 28.5217,
    height: 7.59375,
    stroke: "#CCCCCC"
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    x: 9.50684,
    y: 93.8379,
    width: 28.5217,
    height: 7.59375,
    stroke: "#CCCCCC"
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    x: 9.50684,
    y: 109.032,
    width: 28.5217,
    height: 7.59375,
    stroke: "#CCCCCC"
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    x: 9.50684,
    y: 124.229,
    width: 28.5217,
    height: 7.59375,
    stroke: "#CCCCCC"
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    x: 38.0293,
    y: 71.041,
    width: 143.696,
    height: 7.59375,
    stroke: "#CCCCCC"
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    x: 38.0293,
    y: 86.2393,
    width: 143.696,
    height: 7.59375,
    stroke: "#CCCCCC"
  })), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    x: 38.0293,
    y: 101.433,
    width: 143.696,
    height: 7.59375,
    stroke: "#CCCCCC"
  })), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    x: 38.0293,
    y: 116.631,
    width: 143.696,
    height: 7.59375,
    stroke: "#CCCCCC"
  })), _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    x: 38.0293,
    y: 78.6401,
    width: 143.696,
    height: 7.59375,
    stroke: "#CCCCCC"
  })), _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
    x: 38.0293,
    y: 93.8379,
    width: 143.696,
    height: 7.59375,
    stroke: "#CCCCCC"
  })), _rect51 || (_rect51 = /*#__PURE__*/React.createElement("rect", {
    x: 38.0293,
    y: 109.032,
    width: 143.696,
    height: 7.59375,
    stroke: "#CCCCCC"
  })), _rect52 || (_rect52 = /*#__PURE__*/React.createElement("rect", {
    x: 38.0293,
    y: 124.229,
    width: 143.696,
    height: 7.59375,
    stroke: "#CCCCCC"
  })), _rect53 || (_rect53 = /*#__PURE__*/React.createElement("rect", {
    x: 185.541,
    y: 9.45557,
    width: 47.5362,
    height: 4.6875,
    fill: "#E0E0E0"
  })), _rect54 || (_rect54 = /*#__PURE__*/React.createElement("rect", {
    x: 9.50684,
    y: 46.4868,
    width: 28.5217,
    height: 7.58929,
    fill: "#EEEEEE",
    stroke: "#CCCCCC"
  })), _rect55 || (_rect55 = /*#__PURE__*/React.createElement("rect", {
    x: 38.0283,
    y: 46.4868,
    width: 28.5217,
    height: 7.58929,
    stroke: "#CCCCCC"
  })), _rect56 || (_rect56 = /*#__PURE__*/React.createElement("rect", {
    x: 72.4932,
    y: 46.4868,
    width: 28.5217,
    height: 7.58929,
    fill: "#EEEEEE",
    stroke: "#CCCCCC"
  })), _rect57 || (_rect57 = /*#__PURE__*/React.createElement("rect", {
    x: 101.015,
    y: 46.4868,
    width: 28.5217,
    height: 7.58929,
    stroke: "#CCCCCC"
  })), _rect58 || (_rect58 = /*#__PURE__*/React.createElement("rect", {
    x: 135.479,
    y: 46.4868,
    width: 28.5217,
    height: 7.58929,
    fill: "#EEEEEE",
    stroke: "#CCCCCC"
  })), _rect59 || (_rect59 = /*#__PURE__*/React.createElement("rect", {
    x: 164,
    y: 46.4868,
    width: 28.5217,
    height: 7.58929,
    stroke: "#CCCCCC"
  })), _rect60 || (_rect60 = /*#__PURE__*/React.createElement("rect", {
    x: 198.464,
    y: 46.4868,
    width: 28.5217,
    height: 7.58929,
    fill: "#EEEEEE",
    stroke: "#CCCCCC"
  })), _rect61 || (_rect61 = /*#__PURE__*/React.createElement("rect", {
    x: 226.985,
    y: 46.4868,
    width: 28.5217,
    height: 7.58929,
    stroke: "#CCCCCC"
  })), _rect62 || (_rect62 = /*#__PURE__*/React.createElement("rect", {
    x: 261.523,
    y: 46.4868,
    width: 28.5217,
    height: 7.58929,
    fill: "#EEEEEE",
    stroke: "#CCCCCC"
  })), _rect63 || (_rect63 = /*#__PURE__*/React.createElement("rect", {
    x: 290.045,
    y: 46.4868,
    width: 28.5217,
    height: 7.58929,
    stroke: "#CCCCCC"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbnail3B);
export default __webpack_public_path__ + "static/media/thumbnail-3-b.9b266648c5e7b40b604d1faf7933efd2.svg";
export { ForwardRef as ReactComponent };